"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportDate = ReportDate;
exports.ReportPopup = ReportPopup;
exports.ReportReviews = ReportReviews;
var _Forum2 = _interopRequireDefault(require("@mui/icons-material/Forum"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _OpenInFull2 = _interopRequireDefault(require("@mui/icons-material/OpenInFull"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _ThumbUp2 = _interopRequireDefault(require("@mui/icons-material/ThumbUp"));
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _ThumbDown2 = _interopRequireDefault(require("@mui/icons-material/ThumbDown"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _components = require("../../components");
var _models = require("../../models");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ReportDate({
  report: {
    created,
    creator,
    startDate,
    endDate
  },
  source
}) {
  const from = startDate && startDate.format('LL') || null;
  const to = endDate && endDate.format('LL') || null;
  if (from && to) return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.periods.from_to",
    values: {
      from,
      to
    }
  });
  if (from) return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.periods.from",
    values: {
      from
    }
  });
  if (to) return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.periods.until",
    values: {
      to
    }
  });
  if (!source && creator) return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.created_by_on",
    values: {
      creator,
      created: created.format('LL')
    }
  });
  return /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.created_on",
    values: {
      created: created.format('LL')
    }
  });
}
function ReportReviews({
  currentUser,
  report,
  onRating
}) {
  const [loading, setLoading] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setLoading(false);
  }, [report]);
  function handleRating(rating) {
    const ownReview = reviews?.find(({
      creator,
      rating
    }) => creator?.id === currentUser?.id && rating) || null;
    setLoading(true);
    onRating(report, ownReview, rating);
  }
  const {
    reviews
  } = report;
  const ownReview = reviews?.find(({
    creator,
    rating
  }) => creator?.id === currentUser?.id && rating) || null;
  const nbUsefulReviews = reviews?.filter(({
    rating
  }) => rating === _models.Ratings.Useful).length || 0;
  const nbNegativeReviews = reviews?.filter(({
    rating
  }) => rating === _models.Ratings.NotUseful).length || 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: ownReview?.rating === _models.Ratings.NotUseful ? 'error' : 'inherit',
    disabled: loading,
    onClick: () => handleRating(_models.Ratings.NotUseful),
    size: "small",
    startIcon: /*#__PURE__*/_react.default.createElement(_ThumbDown2.default, null),
    variant: "outlined"
  }, "(", nbNegativeReviews, ")"), /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: ownReview?.rating === _models.Ratings.Useful ? 'success' : 'inherit',
    disabled: loading,
    onClick: () => handleRating(_models.Ratings.Useful),
    size: "small",
    startIcon: /*#__PURE__*/_react.default.createElement(_ThumbUp2.default, null),
    variant: "outlined"
  }, "(", nbUsefulReviews, ")"));
}
function ReportPopup({
  currentUser,
  report,
  theme,
  types,
  sourcesMap,
  onClose,
  onDetailsClick,
  openCommentsDialog,
  onRating
}) {
  const [showedPhotos, showPhotos] = (0, _react.useState)(null);
  const [photosDialogOpen, openPhotosDialog] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    typeCode,
    photoUrl,
    sourceId,
    description,
    reviews
  } = report;
  const source = sourceId !== null && sourcesMap?.[sourceId] || null;
  const nbComments = reviews?.filter(({
    comment
  }) => comment).length || 0;
  function handlePhotosDialogOpen() {
    if (!report.photoUrl) return;
    showPhotos([{
      title: `${t(types?.find(value => value.code === typeCode)?.titleKey || 'commons.report.default_title')} ${report.id}`,
      url: report.photoUrl
    }]);
    openPhotosDialog(true);
  }
  function handlePhotosDialogClose() {
    openPhotosDialog(false);
    setTimeout(() => showPhotos(null), theme.transitions.duration.leavingScreen);
  }
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), /*#__PURE__*/_react.default.createElement(StyledHeader, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(StyledTitle, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: types?.find(value => value.code === typeCode)?.titleKey || 'commons.report.default_title'
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0#", report.id)))), photoUrl && /*#__PURE__*/_react.default.createElement(StyledPhoto, {
    image: photoUrl
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.show_photo"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: handlePhotosDialogOpen,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_OpenInFull2.default, {
    fontSize: "small"
  }))))), /*#__PURE__*/_react.default.createElement(StyledContent, {
    style: {
      paddingTop: photoUrl ? 16 : 0
    }
  }, source && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.report.source",
    values: {
      source: source.title
    }
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    gutterBottom: true,
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(ReportDate, {
    report: report,
    source: source
  })), description && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, description)), (onDetailsClick || openCommentsDialog || onRating) && /*#__PURE__*/_react.default.createElement(StyledActions, null, onDetailsClick && /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "primary",
    onClick: onDetailsClick,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.more_details"
  })), openCommentsDialog && /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "inherit",
    onClick: () => openCommentsDialog(true),
    size: "small",
    startIcon: /*#__PURE__*/_react.default.createElement(_Forum2.default, null),
    variant: "outlined"
  }, "(", nbComments, ")"), onRating && /*#__PURE__*/_react.default.createElement(ReportReviews, {
    currentUser: currentUser,
    onRating: onRating,
    report: report
  }))), /*#__PURE__*/_react.default.createElement(_components.PhotosDialog, {
    onClose: handlePhotosDialogClose,
    open: photosDialogOpen,
    photos: showedPhotos
  }));
}
const Wrapper = _styledComponents.styled.div`
  display: flex;
  flex-direction: column;
  max-height: max(calc(50vh - 24px), 400px);
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 350px);
`;
const CloseButtonWrapper = _styledComponents.styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledHeader = _styledComponents.styled.div`
  display: flex;
  flex-shrink: 0;
  padding: 16px 16px 8px 16px;

  &.shifted {
    padding: 16px 54px 8px 16px;
  }
`;
const StyledTitle = (0, _styledComponents.styled)(_Typography2.default)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledPhoto = _styledComponents.styled.div`
  background-image: ${({
  image
}) => `url(${image})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50%;
  position: relative;

  div {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    position: absolute;
    right: 8px;
    top: 8px;
  }
`;
const StyledContent = _styledComponents.styled.div`
  flex-shrink: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
`;
const StyledActions = _styledComponents.styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  height: 48px;
  padding: 0 16px;

  button {
    margin-left: 8px;
  }
`;